/* BEVANUP_MOBILE_MENU_SCROLL_LOCK_V3 */
(() => {
  if (window.__bevanupMobileMenuScrollLockV3) return;
  window.__bevanupMobileMenuScrollLockV3 = true;
  const root = document.documentElement;
  const body = document.body;
  const original = { position: body.style.position, top: body.style.top, left: body.style.left, right: body.style.right, width: body.style.width };
  let savedY = 0;
  let locked = false;
  const menu = () => document.querySelector('.bevanup-mobile-menu');
  const isOpen = () => root.classList.contains('bevanup-mobile-menu-open') && !menu()?.hidden;
  const lock = () => {
    if (locked) return;
    savedY = window.scrollY;
    body.style.position = 'fixed';
    body.style.top = '-' + savedY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    locked = true;
  };
  const unlock = () => {
    if (!locked) return;
    body.style.position = original.position;
    body.style.top = original.top;
    body.style.left = original.left;
    body.style.right = original.right;
    body.style.width = original.width;
    const restoreY = savedY;
    locked = false;
    requestAnimationFrame(() => window.scrollTo(0, restoreY));
  };
  const sync = () => isOpen() ? lock() : unlock();
  new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('wheel', (event) => { if (isOpen() && !menu()?.contains(event.target)) event.preventDefault(); }, { capture: true, passive: false });
  document.addEventListener('touchmove', (event) => { if (isOpen() && !menu()?.contains(event.target)) event.preventDefault(); }, { capture: true, passive: false });
  sync();
})();
